'use client';

import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import SignIn from '@/components/auth/SignIn';
import { useAuth } from '../../hooks/useAuth';

export default function LoginPage() {
  const searchParams = useSearchParams();
  const messageParam = searchParams?.get('message');
  const sessionExpired = messageParam === 'session_expired';

  const { isAuthenticated, isLoading, status } = useAuth({
    redirectIfAuthenticated: '/dashboard',
  });

  const [isLeaving, setIsLeaving] = useState(false);

  // Debug logging
  console.log('[LoginPage]', { isAuthenticated, isLoading, status });

  // If already authenticated, redirect immediately
  if (isAuthenticated && !isLoading) {
    console.log('[LoginPage] User is authenticated, redirecting to dashboard');
    return null; // This will trigger the redirect in useAuth
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#522e90] px-4">
      <div className="w-full max-w-md">
        <AnimatePresence>
          {!isLeaving && (
            <motion.div
              animate={{ opacity: 1, y: 0 }}
              className="rounded-[5px] bg-[#2a273f] p-6"
              exit={{ opacity: 0, y: -100 }}
              initial={{ opacity: 0, y: 40 }}
              key="login-block"
              transition={{ duration: 0.4, ease: 'easeInOut' }}
            >
              <Image
                alt="Sleep Architects Logo"
                className="mx-auto mb-8 h-12 w-auto"
                height={48}
                src="https://sax-s3-us-east-1-1x-p-public-assets.s3.us-east-1.amazonaws.com/images/Group.png"
                width={120}
              />

              {sessionExpired && (
                <div className="mb-4 rounded-md bg-yellow-100 p-3 text-yellow-900">
                  Session expired. Please log in again.
                </div>
              )}

              <SignIn onStartExit={() => setIsLeaving(true)} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
